import { render, staticRenderFns } from "./EDocumentsCategoryForm.vue?vue&type=template&id=f5a4e1dc&"
import script from "./EDocumentsCategoryForm.vue?vue&type=script&lang=js&"
export * from "./EDocumentsCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports